/* eslint-disable */
import { AspidaClient } from 'aspida'
import { Methods as Methods0 } from './traffic_info.json'

const api = <T>({ baseURL, fetch }: AspidaClient<T>) => {
  const prefix = (baseURL === undefined ? 'https://i.opentidkeio.jp/data/' : baseURL).replace(/\/$/, '')
  const PATH0 = '/traffic_info.json'
  const GET = 'GET'

  return {
    traffic_info_json: {
      get: (option?: { config?: T }) =>
        fetch<Methods0['get']['resBody']>(prefix, PATH0, GET, option).json(),
      $get: (option?: { config?: T }) =>
        fetch<Methods0['get']['resBody']>(prefix, PATH0, GET, option).json().then(r => r.body),
      $path: () => `${prefix}${PATH0}`
    }
  }
}

export type ApiInstance = ReturnType<typeof api>
export default api
